__turbopack_context__.v({
  "delay0s": "version-check-provider-module__T5yPcq__delay0s",
  "delay1_5s": "version-check-provider-module__T5yPcq__delay1_5s",
  "delay1s": "version-check-provider-module__T5yPcq__delay1s",
  "delay2s": "version-check-provider-module__T5yPcq__delay2s",
  "delay4s": "version-check-provider-module__T5yPcq__delay4s",
  "duration10s": "version-check-provider-module__T5yPcq__duration10s",
  "duration6s": "version-check-provider-module__T5yPcq__duration6s",
  "float": "version-check-provider-module__T5yPcq__float",
  "floatAnimation": "version-check-provider-module__T5yPcq__floatAnimation",
  "gradient-shift": "version-check-provider-module__T5yPcq__gradient-shift",
  "gradientShiftAnimation": "version-check-provider-module__T5yPcq__gradientShiftAnimation",
  "morphing-glow": "version-check-provider-module__T5yPcq__morphing-glow",
  "morphingGlowAnimation": "version-check-provider-module__T5yPcq__morphingGlowAnimation",
  "noteBullet": "version-check-provider-module__T5yPcq__noteBullet",
  "orbital": "version-check-provider-module__T5yPcq__orbital",
  "orbitalAnimation": "version-check-provider-module__T5yPcq__orbitalAnimation",
  "wave-pulse": "version-check-provider-module__T5yPcq__wave-pulse",
  "wavePulseAnimation": "version-check-provider-module__T5yPcq__wavePulseAnimation",
});
